import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "wrapper no-gap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_CharacterTable = _resolveComponent("CharacterTable")!
  const _component_CharStatsTable = _resolveComponent("CharStatsTable")!
  const _component_GearTable = _resolveComponent("GearTable")!
  const _component_ResistanceTable = _resolveComponent("ResistanceTable")!
  const _component_EquipPanel = _resolveComponent("EquipPanel")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "char-stats-container",
    title: _ctx.panelTitle
  }, {
    "icons-right": _withCtx(() => [
      _withDirectives(_createVNode(_component_GenericButton, {
        svg: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.panelState = 'default'))
      }, null, 512), [
        [_vShow, _ctx.panelState !== 'default']
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.panelState === 'default')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_CharacterTable),
            _createVNode(_component_CharStatsTable),
            _createVNode(_component_GearTable, { onEquip: _ctx.equipGear }, null, 8, ["onEquip"]),
            _createVNode(_component_ResistanceTable)
          ]))
        : (['head', 'body'].includes(_ctx.panelState))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_EquipPanel, {
                "gear-slot": _ctx.panelState,
                onEquip: _ctx.equipGear,
                onResetView: _cache[1] || (_cache[1] = ($event: any) => (_ctx.panelState = 'default'))
              }, null, 8, ["gear-slot", "onEquip"])
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}